export const TRACK_PAGE_VIEW_START = 'TRACK_PAGE_VIEW_START';
export const TRACK_EVENT_START = 'TRACK_EVENT_START';
export const TRACK_SUCCESS = 'TRACK_SUCCESS';
export const TRACK_ERROR = 'TRACK_ERROR';
